import React from "react";
import { IconProps } from "../icon";

export const RadioIcon = ({ size = "24px", color = "#e5d2ff", ...props }: IconProps<string, string>) => (
  <svg width={size} height={size} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx="6" cy="6" r="5.5" fill="white" stroke={color} />
  </svg>
);
